<app-educational-forum-list [classrooms]="classrooms"></app-educational-forum-list>